import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import {
  Table,
  Button,
  Row,
  Col,
  ButtonGroup,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";
import Baja from "../../Baja";

function CortesPendientesRecibirCuentas() {
  const { user } = useContext(AuthContext);
  const URL_PROCESOS_SALIDA = process.env.REACT_APP_URL_PROCESOS_SALIDA;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_DETALLE_HABILITACION_CORTES = process.env.REACT_APP_URL_DETALLE_HABILITACION_CORTES;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 30);

  let comp8 = new Date();
  comp8.setDate(comp8.getDate() + 8);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");
  let compromiso8 = moment(comp8).format("YYYY-MM-DD");

  const [procesos, setProcesos] = useState([]);

  const [selectedFechaInicio, setSelectedFechaInicio] = useState("2000-01-01");
  const [selectedFechaFin, setSelectedFechaFin] = useState("3000-12-31");

  const [maquileros, setMaquileros] = useState([]);
  const [selectedMaquilero, setSelectedMaquilero] = useState("");
  const [selectedVencido, setSelectedVencido] = useState("");

  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);
  const [idEdit, setIdEdit] = useState();
  const [fecha, setFecha] = useState();
  const [subtotal, setSubtotal] = useState();
  const [iva, setIva] = useState();
  const [descripcion, setDescripcion] = useState("");
  const [totalEdit, setTotalEdit] = useState();
  const [conceptosGastos, setConceptosGastos] = useState([]);
  const [selectedConcepto, setSelectedConcepto] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50000000;

useMemo(() => {
  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  const cargarProcesos = async () => {
    try {
      const response = await axios.get(
        `${URL_PROCESOS_SALIDA}FechasActivos/${selectedFechaInicio}/${selectedFechaFin}`,
        { headers }
      );

      let allProcesos = response.data;

      // Totales de habilitación de TODOS los procesos en UNA sola petición (evita el N+1)
      let totalesHab = {};
      try {
        const resHab = await axios.post(
          `${URL_DETALLE_HABILITACION_CORTES}/totalesPorProceso`,
          { procesos: allProcesos.map((a) => a._id) },
          { headers }
        );
        totalesHab = resHab.data || {};
      } catch (errorHab) {
        console.log("Error totales habilitación:", errorHab);
      }

      const arrayTabla = allProcesos
        .sort((a, b) => (a.fechaCompromiso > b.fechaCompromiso ? 1 : -1))
        .map((a) => {
            const totalHabilitacion = Number(totalesHab[a._id] || 0);

            return {
              _id: a._id,
              status: a.status,
              fecha: a.fecha,
              fechaCompromiso: a.fechaCompromiso,
              maquilero: a.proveedores?.[0]?.nombre_comercial || "",
              idMaquilero: a.proveedores?.[0]?._id || "",
              pedido: a.pedidos?.[0]?.idPedido || "",
              pedidoCliente: a.pedidos?.[0]?.pedidoCliente || "",
              proceso: a.catalogoProcesos?.[0]?.name || "",
              idProceso: a.catalogoProcesos?.[0]?._id || "",
              corte: a.cortes?.[0]?.idCorte || "",
              cantidad: Number(a.totalPiezas || 0),
              articulo:
                `${a.articulos?.[0]?.articulosPadre?.[0]?.codigo || ""} / ` +
                `${a.articulos?.[0]?.articulosPadre?.[0]?.codigoCliente || ""} / ` +
                `${a.articulos?.[0]?.nombre || ""}`,
              idArticulo: a.articulos?.[0]?._id || "",
              recibido: Number(a.recibido || 0),
              pendiente: Number(a.totalPiezas || 0) - Number(a.recibido || 0),
              OP: a.cortes?.[0]?.ordenesCorte?.[0]?.numeroOP || "",
              precio: Number(a.precio || 0),
              totalGeneral: Number(a.totalGeneral || 0),

              // NUEVO
              totalHabilitacion,
              porcentaje: (totalHabilitacion / Number(a.totalGeneral || 0)) * 100,
              total: a.totalGeneral - totalHabilitacion,
              costoPieza: (a.totalGeneral - totalHabilitacion) / Number(a.totalPiezas || 0) || 0,

              entregaActual: Number(a.entregaActual || 0),

              balanceMaquilero: a.proveedores?.[0]?.saldo || 0,
            };
          });

      const dataFinal = arrayTabla.filter((el) => el != null);

      setComments(dataFinal);
      setProcesos(dataFinal);
    } catch (err) {
      console.log(err);
    }
  };

  cargarProcesos();

  axios
    .get(`${URL_PROVEEDORES}Maquileros`, { headers })
    .then((response) => {
      setMaquileros(response.data);
    })
    .catch((err) => {
      console.log(err);
    });
}, [user, selectedFechaInicio, selectedFechaFin]);

  let total = 0;
  let totalTabla = 0;
  let totalRecibido = 0;
  let totalPendiente = 0;

function PDFTabla() {
  const money = (v) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(Number(v || 0));

  const number = (v) => new Intl.NumberFormat("en-US").format(Number(v || 0));

  const dataFiltrada = procesos.filter((c) => {
    return (
      (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
      (selectedFechaFin == 0 || selectedFechaFin >= c.fecha)
    );
  });

  const agrupadoProveedor = dataFiltrada.reduce((acc, c) => {
    const key = c.maquilero || "Sin proveedor";
    if (!acc[key]) acc[key] = [];
    acc[key].push(c);
    return acc;
  }, {});

  const body = [];

  let totalGeneralEntregaActual = 0;
  let totalGeneralMonto = 0;
  let totalGeneralBalance = 0;
  let totalGeneralConBalance = 0;

  Object.entries(agrupadoProveedor).forEach(([proveedor, items]) => {
    body.push([
      {
        content: proveedor,
        colSpan: 13,
        styles: {
          fillColor: [233, 236, 239],
          textColor: [0, 0, 0],
          fontStyle: "bold",
          halign: "left",
        },
      },
    ]);

    let totalEntregaActual = 0;
    let totalMonto = 0;
    const balanceMaquilero = Number(items?.[0]?.balanceMaquilero || 0);

    items.forEach((c) => {
      const entregaActual = Number(c.entregaActual || 0);
      const monto = entregaActual * Number(c.costoPieza || 0);

      totalEntregaActual += entregaActual;
      totalMonto += monto;

      totalGeneralEntregaActual += entregaActual;
      totalGeneralMonto += monto;

      body.push([
        c.fechaCompromiso,
        c.articulo,
        c.OP,
        number(c.cantidad),
        money(c.precio),
        money(c.totalGeneral),
        money(c.totalHabilitacion),
        money(c.total),
        money(c.costoPieza),
        number(c.recibido),
        number(c.pendiente),
        number(c.entregaActual),
        money(monto),
      ]);
    });

    const totalConBalance = totalMonto + balanceMaquilero;

    totalGeneralBalance += balanceMaquilero;
    totalGeneralConBalance += totalConBalance;

    body.push([
      {
        content: `Total ${proveedor}`,
        colSpan: 11,
        styles: {
          fontStyle: "bold",
          halign: "right",
        },
      },
      {
        content: number(totalEntregaActual),
        styles: {
          fontStyle: "bold",
          halign: "right",
        },
      },
      {
        content: money(totalMonto),
        styles: {
          fontStyle: "bold",
          halign: "right",
        },
      },
    ]);

    body.push([
      {
        content: "Balance maquilero",
        colSpan: 12,
        styles: {
          fontStyle: "bold",
          halign: "right",
        },
      },
      {
        content: money(balanceMaquilero),
        styles: {
          fontStyle: "bold",
          halign: "right",
        },
      },
    ]);

    body.push([
      {
        content: "Total con balance",
        colSpan: 12,
        styles: {
          fontStyle: "bold",
          halign: "right",
        },
      },
      {
        content: money(totalConBalance),
        styles: {
          fontStyle: "bold",
          halign: "right",
        },
      },
    ]);
  });

  const doc = new jsPDF("landscape");

  const img = new Image();
  img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
  doc.addImage(img, "png", 230, 15, 45, 15);

  const img2 = new Image();
  img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
  doc.addImage(img2, "png", 120, 10, 60, 25);

  doc.setFontSize(14);
  doc.text("Nómina Maquileros", 20, 20);

  doc.autoTable({
    head: [
      [
        // "Fecha Comp.",
        "Articulo",
        "OP",
        "Cantidad",
        "Precio",
        "Subtotal",
        "Material Total",
        "Total",
        "Costo x Pieza",
        "Recibido",
        "Pendiente",
        "Entrega Actual",
        "Monto",
      ],
    ],
    body,
    startY: 40,
    styles: {
      fontSize: 7,
      cellPadding: 2,
      overflow: "linebreak",
    },
    headStyles: {
      fontStyle: "bold",
    },
    columnStyles: {
      0: { cellWidth: 20 },
      1: { cellWidth: 45 },
      2: { cellWidth: 18 },
      3: { halign: "right" },
      4: { halign: "right" },
      5: { halign: "right" },
      6: { halign: "right" },
      7: { halign: "right" },
      8: { halign: "right" },
      9: { halign: "right" },
      10: { halign: "right" },
      11: { halign: "right" },
      12: { halign: "right" },
    },
    foot: [
      [
        {
          content: "TOTAL GENERAL",
          colSpan: 11,
          styles: {
            fontStyle: "bold",
            halign: "right",
          },
        },
        {
          content: number(totalGeneralEntregaActual),
          styles: {
            fontStyle: "bold",
            halign: "right",
          },
        },
        {
          content: money(totalGeneralMonto),
          styles: {
            fontStyle: "bold",
            halign: "right",
          },
        },
      ],
      [
        {
          content: "BALANCE GENERAL",
          colSpan: 12,
          styles: {
            fontStyle: "bold",
            halign: "right",
          },
        },
        {
          content: money(totalGeneralBalance),
          styles: {
            fontStyle: "bold",
            halign: "right",
          },
        },
      ],
      [
        {
          content: "TOTAL GENERAL CON BALANCE",
          colSpan: 12,
          styles: {
            fontStyle: "bold",
            halign: "right",
          },
        },
        {
          content: money(totalGeneralConBalance),
          styles: {
            fontStyle: "bold",
            halign: "right",
          },
        },
      ],
    ],
    showFoot: "lastPage",
  });

  doc.save("ProcesosPendientes.pdf");
}

function excel() {
  const dataFiltrada = procesos.filter((c) => {
    return (
      (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
      (selectedFechaFin == 0 || selectedFechaFin >= c.fecha)
    );
  });

  const agrupadoProveedor = dataFiltrada.reduce((acc, c) => {
    const key = c.maquilero || "Sin proveedor";
    if (!acc[key]) acc[key] = [];
    acc[key].push(c);
    return acc;
  }, {});

  const dataExcelLimpia = [];

  let totalGeneralEntregaActual = 0;
  let totalGeneralMonto = 0;
  let totalGeneralBalance = 0;
  let totalGeneralConBalance = 0;

  Object.entries(agrupadoProveedor).forEach(([proveedor, items]) => {
    const itemsConEntrega = items.filter(
      (c) => Number(c.entregaActual || 0) > 0
    );

    if (itemsConEntrega.length === 0) return;

    dataExcelLimpia.push({
      FechaCompromiso: proveedor,
      Articulo: "",
      OP: "",
      Cantidad: "",
      Precio: "",
      Subtotal: "",
      MaterialTotal: "",
      Total: "",
      CostoPieza: "",
      Recibido: "",
      Pendiente: "",
      EntregaActual: "",
      Monto: "",
    });

    let totalEntregaActual = 0;
    let totalMonto = 0;
    const balanceMaquilero = Number(items?.[0]?.balanceMaquilero || 0);

    itemsConEntrega.forEach((c) => {
      const entregaActual = Number(c.entregaActual || 0);
      const monto = entregaActual * Number(c.costoPieza || 0);

      totalEntregaActual += entregaActual;
      totalMonto += monto;

      totalGeneralEntregaActual += entregaActual;
      totalGeneralMonto += monto;

      dataExcelLimpia.push({
        FechaCompromiso: c.fechaCompromiso,
        Articulo: c.articulo,
        OP: c.OP,
        Cantidad: Number(c.cantidad || 0),
        Precio: Number(c.precio || 0),
        Subtotal: Number(c.totalGeneral || 0),
        MaterialTotal: Number(c.totalHabilitacion || 0),
        Total: Number(c.total || 0),
        CostoPieza: Number(c.costoPieza || 0),
        Recibido: Number(c.recibido || 0),
        Pendiente: Number(c.pendiente || 0),
        EntregaActual: entregaActual,
        Monto: monto,
      });
    });

    const totalConBalance = totalMonto + balanceMaquilero;

    totalGeneralBalance += balanceMaquilero;
    totalGeneralConBalance += totalConBalance;

    dataExcelLimpia.push({
      FechaCompromiso: `Total ${proveedor}`,
      Articulo: "",
      OP: "",
      Cantidad: "",
      Precio: "",
      Subtotal: "",
      MaterialTotal: "",
      Total: "",
      CostoPieza: "",
      Recibido: "",
      Pendiente: "",
      EntregaActual: totalEntregaActual,
      Monto: totalMonto,
    });

    dataExcelLimpia.push({
      FechaCompromiso: "Balance maquilero",
      Articulo: "",
      OP: "",
      Cantidad: "",
      Precio: "",
      Subtotal: "",
      MaterialTotal: "",
      Total: "",
      CostoPieza: "",
      Recibido: "",
      Pendiente: "",
      EntregaActual: "",
      Monto: balanceMaquilero,
    });

    dataExcelLimpia.push({
      FechaCompromiso: "Total con balance",
      Articulo: "",
      OP: "",
      Cantidad: "",
      Precio: "",
      Subtotal: "",
      MaterialTotal: "",
      Total: "",
      CostoPieza: "",
      Recibido: "",
      Pendiente: "",
      EntregaActual: "",
      Monto: totalConBalance,
    });

    dataExcelLimpia.push({
      FechaCompromiso: "",
      Articulo: "",
      OP: "",
      Cantidad: "",
      Precio: "",
      Subtotal: "",
      MaterialTotal: "",
      Total: "",
      CostoPieza: "",
      Recibido: "",
      Pendiente: "",
      EntregaActual: "",
      Monto: "",
    });
  });

  dataExcelLimpia.push({
    FechaCompromiso: "TOTAL GENERAL",
    Articulo: "",
    OP: "",
    Cantidad: "",
    Precio: "",
    Subtotal: "",
    MaterialTotal: "",
    Total: "",
    CostoPieza: "",
    Recibido: "",
    Pendiente: "",
    EntregaActual: totalGeneralEntregaActual,
    Monto: totalGeneralMonto,
  });

  dataExcelLimpia.push({
    FechaCompromiso: "BALANCE GENERAL",
    Articulo: "",
    OP: "",
    Cantidad: "",
    Precio: "",
    Subtotal: "",
    MaterialTotal: "",
    Total: "",
    CostoPieza: "",
    Recibido: "",
    Pendiente: "",
    EntregaActual: "",
    Monto: totalGeneralBalance,
  });

  dataExcelLimpia.push({
    FechaCompromiso: "TOTAL GENERAL CON BALANCE",
    Articulo: "",
    OP: "",
    Cantidad: "",
    Precio: "",
    Subtotal: "",
    MaterialTotal: "",
    Total: "",
    CostoPieza: "",
    Recibido: "",
    Pendiente: "",
    EntregaActual: "",
    Monto: totalGeneralConBalance,
  });

  const option = {};

  option.fileName = `ProcesosCorte-${selectedFechaInicio}-${selectedFechaFin}`;

  option.datas = [
    {
      sheetData: dataExcelLimpia,
      sheetName: `ProcesosCorte`,
      sheetFilter: [
        "FechaCompromiso",
        "Articulo",
        "OP",
        "Cantidad",
        "Precio",
        "Subtotal",
        "MaterialTotal",
        "Total",
        "CostoPieza",
        "Recibido",
        "Pendiente",
        "EntregaActual",
        "Monto",
      ],
      sheetHeader: [
        // "Fecha Comp.",
        "Articulo",
        "OP",
        "Cantidad",
        "Precio",
        "Subtotal",
        "Material Total",
        "Total",
        "Costo x Pieza",
        "Recibido",
        "Pendiente",
        "Entrega Actual",
        "Monto",
      ],
    },
  ];

  const toExcel = new ExportJsonExcel(option);
  toExcel.saveExcel();
}

  const headers = [
    // { name: "Maquilero", field: "maquilero", sortable: true },
    // { name: "Fecha Compromiso", field: "fechaCompromiso", sortable: true },
    { name: "Articulo", field: "articulo", sortable: true },
    { name: "OP", field: "OP", sortable: true },
    { name: "Cantidad", field: "cantidad", sortable: true },
    { name: "Precio", field: "precio", sortable: true },
    { name: "Subtotal", field: "totalGeneral", sortable: true },
    { name: "Material Total", field: "totalHabilitacion", sortable: true },
    { name: "Total", field: "total", sortable: true },
    { name: "Costo x Pieza", field: "costoPieza", sortable: true },
    { name: "Recibido", field: "recibido", sortable: true },
    { name: "Pendiente", field: "pendiente", sortable: true },
    { name: "Entrega Actual", field: "entregaActual", sortable: true },
    { name: "Monto", field: "monto", sortable: true },

  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.maquilero.toLowerCase().includes(search.toLowerCase()) ||
          comment.articulo.toLowerCase().includes(search.toLowerCase()) ||
          comment.OP.toLowerCase().includes(search.toLowerCase()) ||
          comment.cantidad.toString().includes(search) ||
          comment.precio.toString().includes(search) ||
          comment.totalGeneral.toString().includes(search) ||
          comment.totalHabilitacion.toString().includes(search) ||
          comment.total.toString().includes(search) ||
          comment.recibido.toString().includes(search) ||
          comment.pendiente.toString().includes(search) 
      );
    }

    setTotalItems(computedComments.length);

     //Sorting comments
    if (
      sorting.field &&
      sorting.field != "cantidad" &&
      sorting.field != "precio" &&
      sorting.field != "totalGeneral" &&
      sorting.field != "totalHabilitacion" &&
      sorting.field != "total" &&
      sorting.field != "costoPieza"  &&
      sorting.field != "recibido" &&
      sorting.field != "pendiente"&&
      sorting.field != "entregaActual" &&
      sorting.field != "monto"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "cantidad" ||
        sorting.field == "precio" ||
        sorting.field == "totalGeneral" ||
        sorting.field == "totalHabilitacion" ||
        sorting.field == "total" ||
        sorting.field == "costoPieza" ||
        sorting.field == "recibido" ||
        sorting.field == "pendiente" ||
        sorting.field == "entregaActual" ||
        sorting.field == "monto")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "cantidad" ||
        sorting.field == "precio" ||
        sorting.field == "totalGeneral" ||
        sorting.field == "totalHabilitacion" ||
        sorting.field == "total" ||
        sorting.field == "costoPieza" ||
        sorting.field == "recibido" ||
        sorting.field == "pendiente" ||
        sorting.field == "entregaActual" ||
        sorting.field == "monto")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }


    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedFechaInicio,
    selectedFechaFin,
    // selectedVencido,
  ]);

  function jalaInfo(id, subtotal, iva, total, concepto, descripcion, fecha) {
    setIdEdit(id);
    setSubtotal(subtotal);
    setIva(iva);
    setTotalEdit(total);
    setSelectedConcepto(concepto);
    setDescripcion(descripcion);
    setFecha(fecha);
    toggleEdit();
  }

const actualizaEntregaActual = (id, value) => {
  const entregaActual = value === "" ? 0 : Number(value);

  const actualizar = (array) =>
    array.map((item) => {
      if (item._id !== id) return item;

      return {
        ...item,
        entregaActual,
      };
    });

  setComments((prev) => actualizar(prev));
  setProcesos((prev) => actualizar(prev));
};

async function saveProcesos() {
  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  try {
    // Opcional loader
    showLoader();

    await Promise.all(
      comments.map(async (c) => {
        return axios.patch(
          `${URL_PROCESOS_SALIDA}/${c._id}`,
          {
            entregaActual: Number(c.entregaActual || 0),
          },
          { headers }
        );
      })
    );

    hideLoader();

    Swal.fire({
      icon: "success",
      title: "Guardado",
      text: "Se actualizaron las entregas correctamente",
      timer: 1500,
      showConfirmButton: false,
    });
  } catch (error) {
    hideLoader();
    console.log(error);

    Swal.fire({
      icon: "error",
      title: "Error",
      text: "No se pudieron guardar los cambios",
    });
  }
}

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_produccion ? (
        <div className="row">
          <div className="col-md-12">
            <div className="card style={{ width: 'auto' }}">
              <div className="card-body">
                <Row>
                  <Col md={7}>
                    <Button
                      size="sm"
                      href="/MenuCXP"
                      className="btn btn-danger"
                      id="botonListado"
                    >
                      Regresar
                    </Button>
                  </Col>
                  <Col md={5}>
                    <ButtonGroup id="logoutBoton">
                      <Button
                        size="sm"
                        className="btn"
                        color="info"
                        onClick={saveProcesos}
                      >
                        Guardar <i class="fa-regular fa-floppy-disk"></i>
                      </Button>
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        onClick={PDFTabla}
                      >
                        PDF <i class="far fa-file-pdf"></i>
                      </Button>
                     
                      <Button
                        size="sm"
                        className="btn"
                        color="primary"
                        onClick={excel}
                      >
                        Excel <i class="far fa-file-excel"></i>
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Row>
                <br />
                <h3 align="center">Nómina Maquileros</h3>
                {/* <Row>
                  <Col md={2}>
                    <Label>Fecha Inicio</Label>
                    <Input
                      bsSize="sm"
                      type="date"
                      value={selectedFechaInicio}
                      onChange={(e) => {
                        setSelectedFechaInicio(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Fecha Fin</Label>
                    <Input
                      bsSize="sm"
                      type="date"
                      value={selectedFechaFin}
                      onChange={(e) => {
                        setSelectedFechaFin(e.target.value);
                      }}
                    />
                  </Col>
                   <Col md={2}>
                    <Label>Maquilero</Label>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedMaquilero}
                      onChange={(e) => {
                        setSelectedMaquilero(e.target.value);
                        setCurrentPage(1);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {maquileros
                        .sort((a, b) =>
                          a.nombre_comercial > b.nombre_comercial ? 1 : -1
                        )
                        .map((a) => {
                          return (
                            <option value={a._id}>{a.nombre_comercial}</option>
                          );
                        })}
                    </Input>
                  </Col> 
                </Row> */}
                {/* <br /> */}
                {/* <div className="row">
                  <div className="col-md-6">
                    <Pagination
                      total={totalItems}
                      itemsPerPage={ITEMS_PER_PAGE}
                      currentPage={currentPage}
                      onPageChange={(page) => setCurrentPage(page)}
                    />
                  </div>
                  <div className="col-md-6 d-flex flex-row-reverse">
                    <Search
                      onSearch={(value) => {
                        setSearch(value);
                        setCurrentPage(1);
                      }}
                    />
                  </div>
                </div> */}
<Table
  size="sm"
  striped
  borderless
  className="table-responsive-xl"
>
  <TableHeader
    headers={headers}
    onSorting={(field, order) => setSorting({ field, order })}
  />

  <tbody>
    {Object.entries(
      commentsData.reduce((acc, c) => {
        const key = c.maquilero || "Sin proveedor";
        if (!acc[key]) acc[key] = [];
        acc[key].push(c);
        return acc;
      }, {})
    ).map(([proveedor, items]) => {
      const totalEntregaActual = items.reduce(
        (sum, item) => sum + Number(item.entregaActual || 0),
        0
      );

      const totalMonto = items.reduce(
        (sum, item) =>
          sum +
          Number(item.entregaActual || 0) * Number(item.costoPieza || 0),
        0
      );

      const balanceMaquilero = Number(items?.[0]?.balanceMaquilero || 0);
      const totalConBalance = totalMonto + balanceMaquilero;

      return (
        <React.Fragment key={proveedor}>
          <tr style={{ background: "#e9ecef", fontWeight: "bold" }}>
            <td colSpan="14">{proveedor}</td>
          </tr>

          {items.map((c) => (
            <tr key={c._id}>
              {/* <td>{c.fechaCompromiso}</td> */}
              <td>{c.articulo}</td>
              <td>{c.OP}</td>
              <td>{new Intl.NumberFormat("en-US").format(c.cantidad)}</td>
              <td>
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(c.precio)}
              </td>
              <td>
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(c.totalGeneral)}
              </td>
              <td>
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(c.totalHabilitacion)}
              </td>
              <td>
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(c.total)}
              </td>
              <td>
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(c.costoPieza)}
              </td>
              <td>{new Intl.NumberFormat("en-US").format(c.recibido)}</td>
              <td>{new Intl.NumberFormat("en-US").format(c.pendiente)}</td>
              <td>
                <Input
                  bsSize="sm"
                  type="number"
                  value={c.entregaActual}
                  min="0"
                  onChange={(e) => {
                    actualizaEntregaActual(c._id, e.target.value);
                  }}
                  style={{ width: "90px" }}
                />
              </td>
              <td>
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(
                  Number(c.entregaActual || 0) *
                    Number(c.costoPieza || 0)
                )}
              </td>
            </tr>
          ))}

          {/* Total proveedor */}
          <tr style={{ fontWeight: "bold", background: "#f8f9fa" }}>
            <td colSpan="10" align="right">
              Total {proveedor}
            </td>
            <td>
              {new Intl.NumberFormat("en-US").format(
                totalEntregaActual
              )}
            </td>
            <td>
              {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(totalMonto)}
            </td>
          </tr>

          {/* Balance */}
          <tr style={{ fontWeight: "bold", background: "#fff3cd" }}>
            <td colSpan="10" align="right">
              Balance maquilero
            </td>
            <td></td>
            <td>
              {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(balanceMaquilero)}
            </td>
          </tr>

          {/* Total con balance */}
          <tr style={{ fontWeight: "bold", background: "#d1e7dd" }}>
            <td colSpan="10" align="right">
              Total con balance
            </td>
            <td></td>
            <td>
              {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(totalConBalance)}
            </td>
          </tr>
        </React.Fragment>
      );
    })}
  </tbody>
</Table>
                {/* <div className="col-md-6">
                  <Pagination
                    total={totalItems}
                    itemsPerPage={ITEMS_PER_PAGE}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                  />
                </div> */}
              </div>
            </div>
          </div>
        </div>
      ) : undefined}
      {loader}
    </>
  );
}

export default CortesPendientesRecibirCuentas;
